import { render, staticRenderFns } from "./menuSider.vue?vue&type=template&id=7ee64d43&"
import script from "./menuSider.vue?vue&type=script&lang=js&"
export * from "./menuSider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports